import React, { useState, useEffect } from "react";

import { Form } from "antd";
import { Button, Upload, Modal } from "../../../BP2Components";

import { handleGridTechname, renderDevInfo } from "../../GeneralScripts";
import { useIntl } from "react-intl";
import { getBlob } from "../../../../services/restAPI/RestApi";

import IntlMessages from "@util/IntlMessages";
import projectConfig from "@projectConfig";
import PropTypes from "prop-types";

import "./FileField.less";
import { Icon_Upload, Icon_Upload_Barcode } from "../../../BP2Components/Icons/icons";

const { hostCloud } = projectConfig.api;

const FileField = ({
   isRequired,
   element,
   form,
   isVisible,
   disabled,
   insideGrid = false,
   setChangelogData
}) => {
   // remove when back php fixes file links here and in Upload.tsx
   if (element?.link && typeof element.link === "string" && element.link.includes("http:")) {
      element.link = element.link.replaceAll("http:", "https:");
   }
   const [showModal, setShowModal] = useState(false);
   const [addBarcode, setAddBarecode] = useState(false);
   const [fileId, setFileId] = useState(element.link && element.value);

   const intl = useIntl();

   const { getFieldDecorator } = form;

   const barecodeController = (fieldId) => {
      // modal before choosing file to upload, is function configurated for project
      if (projectConfig?.formAttachmentsModal) {
         setShowModal(true);
      } else {
         const getUploadButton = document.getElementById(fieldId);
         getUploadButton.click();
      }
   };

   const uploadWithoutBarcode = (fieldId) => {
      setAddBarecode(false);
      const getUploadButton = document.getElementById(fieldId);
      getUploadButton.click();
      setShowModal(false);
   };

   const uploadWithBarcode = (fieldId) => {
      setAddBarecode(true);
      const getUploadButton = document.getElementById(fieldId);
      getUploadButton.click();
      setShowModal(false);
   };
   const uploadHandle = (data) => {
      if (data?.name) {
         setChangelogData && setChangelogData(element.tech_name, data.name, element.label);
      }
   };
   const onLoadHandle = (name) => {
      if (name) {
         setChangelogData && setChangelogData(element.tech_name, name);
      }
   };
   const translatedLabel = element.label;

   useEffect(() => {
      const id = form.getFieldValue(element.tech_name);
      if (fileId !== id) {
         setFileId(id);
         // TODO - uncomment and set url if defaultURL will be needed to pass to <Upload>
         /* getBlob(id).then((res) => {
            
         }); */
      }
   }, [JSON.stringify(form.getFieldValue(element.tech_name))]);

   return (
      <Form.Item
         key={element.tech_name}
         label={!insideGrid && translatedLabel}
         className={`${element?.type}-field _type_${element.type}_type_ field_${element.tech_name}`}
         style={{
            display: isVisible(element) ? "" : "none",
            gridArea: handleGridTechname(element.tech_name)
         }}
      >
         <>
            {projectConfig?.formAttachmentsModal && (
               <Button
                  disabled={disabled}
                  buttonType="primary"
                  onClick={() => barecodeController(`field_${element.tech_name}`)}
               >
                  <Icon_Upload
                     className="file-field__icon-upload"
                     style={{ paddingRight: "5px" }}
                  />{" "}
                  <IntlMessages id="forms.clickToUpload" />
               </Button>
            )}
            {getFieldDecorator(element.tech_name, {
               rules: [
                  {
                     required: isRequired(element),
                     message: intl.formatMessage({ id: "field.required" })
                  }
               ],
               initialValue: element.value
            })(
               <Upload
                  uploadUrl={`${hostCloud}/legacy/file/form?formFieldId=${element.object.UIP_ID}`}
                  updateFieldValue={(value) => form.setFieldsValue({ [element.tech_name]: value })}
                  onUpload={(e) => uploadHandle(e)}
                  onLoad={(e) => onLoadHandle(e)}
                  disabled={disabled}
                  defaultFileId={fileId}
                  defaultFileUrl={element.link}
                  addBarcode={addBarcode}
               >
                  <Button
                     buttonType="primary"
                     id={`field_${element.tech_name}`}
                     disabled={disabled}
                     style={{
                        display: projectConfig?.formAttachmentsModal ? "none" : null,
                        backgroundColor: projectConfig?.title.includes("Carlsberg")
                           ? "var(--btn-primaryBackground)"
                           : "#e2e8f0",
                        borderColor: projectConfig?.title.includes("Carlsberg")
                           ? "var(--btn-primaryBackground)"
                           : "#e2e8f0"
                     }}
                  >
                     <Icon_Upload
                        className="file-field__icon-upload"
                        style={{ paddingRight: "5px" }}
                     />{" "}
                     <IntlMessages id="forms.clickToUpload" />
                  </Button>
               </Upload>
            )}
            <Modal isOpen={showModal} onCancel={() => setShowModal(false)}>
               <div
                  className="buttons-container"
                  style={{ textAlign: "center", display: "flex", flexDirection: "row" }}
               >
                  <Button
                     onClick={() => uploadWithoutBarcode(`field_${element.tech_name}`)}
                     className="modal-barcode-button"
                  >
                     <Icon_Upload className="upload-icon" />
                     <IntlMessages className="upload-text" id="upload.without.barcode" />
                  </Button>

                  <Button
                     onClick={() => uploadWithBarcode(`field_${element.tech_name}`)}
                     className="modal-barcode-button"
                  >
                     <Icon_Upload_Barcode className="upload-icon" />
                     <IntlMessages className="upload-text" id="upload.with.barcode" />
                  </Button>
               </div>
            </Modal>
         </>
         {renderDevInfo(element)}
      </Form.Item>
   );
};

FileField.propTypes = {
   element: PropTypes.object.isRequired,
   disabled: PropTypes.bool,
   isVisible: PropTypes.func,
   form: PropTypes.any
};

export default FileField;
